// @flow
import './default-bundle';

import RingCatalog from '@components/pages/settings/RingCatalog';
import SettingProductDetail from '@components/pages/settings/ProductDetail';

ReactOnRails.register({
  RingCatalog,
  SettingProductDetail
});
